import type { RegistrationField } from './types'

// Mirrors EventRegistrationField's name-format helpers. The Full Name default
// field can collect one combined name or a first/last pair; the mode lives in
// `configuration` so no field kind or identifier has to change.
export const DEFAULT_FIRST_NAME_LABEL = 'First Name'
export const DEFAULT_LAST_NAME_LABEL = 'Last Name'

/** The Full Name default field — the only field the split toggle applies to. */
export function isNameField(field: Pick<RegistrationField, 'default_kind'> | null | undefined) {
  return field?.default_kind === 'full_name'
}

export function isSplitName(
  field: Pick<RegistrationField, 'default_kind' | 'configuration'> | null | undefined,
) {
  return isNameField(field) && field?.configuration?.name_format === 'split'
}

export function firstNameLabel(
  field: Pick<RegistrationField, 'configuration'> | null | undefined,
) {
  return field?.configuration?.first_name_label?.trim() || DEFAULT_FIRST_NAME_LABEL
}

export function lastNameLabel(field: Pick<RegistrationField, 'configuration'> | null | undefined) {
  return field?.configuration?.last_name_label?.trim() || DEFAULT_LAST_NAME_LABEL
}
